/* LiberLive — Creative Styles Orbit. Multi-instance, Theme-Editor aware.
   Each [data-styles-orbit] carries its own track list in a <script data-orbit-data> JSON.
   No external libraries; native Audio only; one track plays at a time per instance. */
(function () {
  var ICONS = {
    mic: '<svg viewBox="0 0 24 24"><path d="M12 14a4 4 0 0 0 4-4V6a4 4 0 1 0-8 0v4a4 4 0 0 0 4 4Zm-7-4a7 7 0 0 0 14 0M12 17v4M8 21h8"/></svg>',
    moon: '<svg viewBox="0 0 24 24"><path d="M19 13a7 7 0 1 1-8-8 6 6 0 0 0 8 8Zm0-9v5m-2-2h4"/></svg>',
    heart: '<svg viewBox="0 0 24 24"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z"/></svg>',
    star: '<svg viewBox="0 0 24 24"><path d="m12 2 3 6 6.5 1-4.7 4.6 1.1 6.5-5.9-3.1-5.9 3.1 1.1-6.5L2.5 9 9 8Z"/></svg>'
  };
  var ICON_KEYS = ['mic', 'moon', 'heart', 'star'];

  // i18n: strings are emitted by the section (window.LiberliveI18n.orbit, values via | t).
  // Templates use %s for the track title. Thai fallbacks keep behaviour if the blob is missing.
  var I18N_FALLBACK = {
    play_track: '\u0e40\u0e25\u0e48\u0e19 %s',
    pause_track: '\u0e2b\u0e22\u0e38\u0e14\u0e0a\u0e31\u0e48\u0e27\u0e04\u0e23\u0e32\u0e27 %s',
    select_track: '\u0e40\u0e25\u0e37\u0e2d\u0e01\u0e40\u0e1e\u0e25\u0e07 %s',
    cover_alt: '\u0e20\u0e32\u0e1e\u0e1b\u0e01\u0e40\u0e1e\u0e25\u0e07 %s',
    single_in_genre: '\u0e21\u0e35\u0e40\u0e1e\u0e25\u0e07\u0e40\u0e14\u0e35\u0e22\u0e27\u0e43\u0e19\u0e2b\u0e21\u0e27\u0e14\u0e19\u0e35\u0e49',
    load_error: '\u0e42\u0e2b\u0e25\u0e14\u0e40\u0e2a\u0e35\u0e22\u0e07\u0e44\u0e21\u0e48\u0e2a\u0e33\u0e40\u0e23\u0e47\u0e08'
  };
  function L(key, title) {
    var src = (window.LiberliveI18n && window.LiberliveI18n.orbit) || {};
    var str = (typeof src[key] === 'string' && src[key]) ? src[key] : I18N_FALLBACK[key];
    return title === undefined ? str : str.replace('%s', title);
  }

  function iconFor(track, index) {
    if (track && track.icon && ICONS[track.icon]) return ICONS[track.icon];
    return ICONS[ICON_KEYS[index % ICON_KEYS.length]];
  }

  function seeded(seed, index) {
    var x = Math.sin(seed * 91.7 + index * 17.31) * 43758.5453;
    return x - Math.floor(x);
  }

  function makeWave(container, seed, count) {
    container.replaceChildren();
    var frag = document.createDocumentFragment();
    for (var i = 0; i < count; i += 1) {
      var bar = document.createElement('span');
      var envelope = Math.sin((i / Math.max(1, count - 1)) * Math.PI);
      var height = 12 + (seeded(seed, i) * 66 + envelope * 22);
      bar.style.setProperty('--wave', Math.min(100, height).toFixed(2));
      frag.appendChild(bar);
    }
    container.appendChild(frag);
  }

  function initOrbit(root) {
    if (!root || root.dataset.orbitReady === '1') return;
    var dataEl = root.querySelector('[data-orbit-data]');
    var tracks = [];
    try { tracks = JSON.parse(dataEl.textContent).tracks || []; } catch (e) { tracks = []; }
    if (!tracks.length) { root.dataset.orbitReady = '1'; return; }
    root.dataset.orbitReady = '1';

    var audio = root.querySelector('[data-audio]');
    var image = root.querySelector('[data-featured-image]');
    var title = root.querySelector('[data-featured-title]');
    var genre = root.querySelector('[data-featured-genre]');
    var disc = root.querySelector('[data-featured-play]');
    var discMedia = root.querySelector('[data-disc-media]');
    var playIcon = disc.querySelector('.featured-play-icon');
    var satellites = root.querySelector('[data-satellites]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-genre]'));
    var tabsWrap = root.querySelector('.genre-tabs');
    var timeCur = root.querySelector('[data-time-cur]');
    var timeDur = root.querySelector('[data-time-dur]');
    var errorEl = root.querySelector('[data-featured-error]');
    var retryBtn = root.querySelector('[data-featured-retry]');
    var srStatus = root.querySelector('[data-sr-status]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function fmtTime(s) {
      if (!isFinite(s) || s < 0) s = 0;
      var m = Math.floor(s / 60);
      var sec = Math.floor(s % 60);
      return m + ':' + (sec < 10 ? '0' : '') + sec;
    }
    function setBusy(busy) {
      disc.classList.toggle('is-loading', busy);
      disc.setAttribute('aria-busy', busy ? 'true' : 'false');
    }
    function setError(on) {
      disc.classList.toggle('is-error', on);
      if (errorEl) errorEl.hidden = !on;
    }

    var startIndex = parseInt(root.dataset.defaultIndex, 10);
    if (isNaN(startIndex) || startIndex < 0 || startIndex >= tracks.length) startIndex = 0;
    var current = startIndex;
    var morphTimer = 0;

    function updateTime() {
      var duration = isFinite(audio.duration) ? audio.duration : (tracks[current].duration || 18);
      var ratio = duration ? audio.currentTime / duration : 0;
      disc.style.setProperty('--progress', (ratio * 360) + 'deg');
      if (timeCur) timeCur.textContent = fmtTime(audio.currentTime);
      if (timeDur) timeDur.textContent = fmtTime(duration);
    }

    function setPlaying(playing) {
      playIcon.classList.toggle('is-playing', playing);
      disc.classList.toggle('is-playing', playing);
      disc.setAttribute('aria-label', L(playing ? 'pause_track' : 'play_track', tracks[current].title));
    }

    function markTabs() {
      var activeKey = tracks[current].key;
      tabs.forEach(function (tab) {
        tab.setAttribute('aria-pressed', String(tab.dataset.genre === activeKey));
      });
    }

    function renderSatellites() {
      satellites.replaceChildren();
      var curKey = tracks[current].key;
      var shown = 0;
      tracks.forEach(function (track, index) {
        if (index === current) return;
        if (track.key !== curKey) return;   // only songs in the same genre as the active track
        if (shown >= 3) return;             // the orbit has three satellite slots
        shown += 1;
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'satellite-card';
        card.dataset.index = String(index);
        card.setAttribute('aria-label', L('select_track', track.title));
        card.innerHTML =
          '<img src="' + track.cover + '" alt="' + L('cover_alt', track.title) + '">' +
          '<span class="satellite-meta">' +
            '<span class="satellite-icon" aria-hidden="true">' + iconFor(track, index) + '</span>' +
            '<h3>' + track.title + '</h3>' +
            '<span class="sat-genre">' + track.genre + '</span>' +
            '<span class="waveform satellite-wave" aria-hidden="true"></span>' +
          '</span>';
        makeWave(card.querySelector('.satellite-wave'), index + 1, 28);
        // Select only — do NOT autoplay; the label says "เลือกเพลง", so let the user press play.
        card.addEventListener('click', function () { selectTrack(index, false); });
        satellites.appendChild(card);
      });
      if (shown === 0) {
        var empty = document.createElement('p');
        empty.className = 'satellite-empty';
        empty.textContent = L('single_in_genre');
        satellites.appendChild(empty);
      }
      satellites.setAttribute('data-sat-count', String(shown));
      root.setAttribute('data-sat-count', String(shown)); // drives orbit-line node visibility
    }

    function runMorph(update) {
      window.clearTimeout(morphTimer);
      // remove any ghosts left over from a previous (possibly interrupted) morph — rapid genre
      // switching would otherwise orphan ghost layers because their removal timer was cleared
      discMedia.querySelectorAll('.morph-ghost').forEach(function (g) { g.remove(); });
      var featured = root.querySelector('.featured-track');
      var stage = root.querySelector('.orbit-stage');
      var ghost = image.cloneNode(true);
      ghost.removeAttribute('data-featured-image');
      ghost.classList.add('morph-ghost');
      ghost.alt = '';
      ghost.setAttribute('aria-hidden', 'true');
      discMedia.insertBefore(ghost, image.nextSibling);
      disc.classList.remove('is-morphing');
      featured.classList.remove('is-morphing');
      stage.classList.remove('is-morphing');
      void disc.offsetWidth;
      update();
      disc.classList.add('is-morphing');
      featured.classList.add('is-morphing');
      stage.classList.add('is-morphing');
      morphTimer = window.setTimeout(function () {
        ghost.remove();
        disc.classList.remove('is-morphing');
        featured.classList.remove('is-morphing');
        stage.classList.remove('is-morphing');
      }, 760);
    }

    function selectTrack(index, autoplay, morph) {
      if (morph === undefined) morph = true;
      var wasPlaying = !audio.paused;
      current = (index + tracks.length) % tracks.length;
      var track = tracks[current];
      audio.pause();
      audio.src = track.audio;
      var updateVisuals = function () {
        image.src = track.cover;
        image.alt = L('cover_alt', track.title);
        title.textContent = track.title;
        genre.textContent = track.genre;
      };
      if (morph && !reduce) runMorph(updateVisuals);
      else updateVisuals();
      disc.setAttribute('aria-label', L('play_track', track.title));
      renderSatellites();
      markTabs();
      setError(false);
      setBusy(false);
      audio.load();
      updateTime();
      if (srStatus) srStatus.textContent = track.title + ' — ' + track.genre;
      if (autoplay || wasPlaying) { setBusy(true); audio.play().catch(function () { setPlaying(false); }); }
    }

    function togglePlay() {
      if (audio.paused) audio.play().catch(function () { setPlaying(false); });
      else audio.pause();
    }

    disc.addEventListener('click', togglePlay);

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (tab.hasAttribute('disabled')) return; // genre with no track
        var key = tab.dataset.genre;
        var match = -1;
        for (var i = 0; i < tracks.length; i += 1) { if (tracks[i].key === key) { match = i; break; } }
        if (match >= 0 && match !== current) selectTrack(match, false);
        else if (match >= 0) markTabs();
        // keep the chosen genre centered in the mobile scroll rail
        if (tabsWrap && tabsWrap.scrollWidth > tabsWrap.clientWidth) {
          tab.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    });

    audio.addEventListener('play', function () { setPlaying(true); });
    audio.addEventListener('pause', function () { setPlaying(false); });
    audio.addEventListener('timeupdate', updateTime);
    audio.addEventListener('loadedmetadata', updateTime);
    // Loading / ready / error states (CS-14)
    audio.addEventListener('waiting', function () { setBusy(true); });
    audio.addEventListener('loadstart', function () { setBusy(true); });
    audio.addEventListener('canplay', function () { setBusy(false); setError(false); });
    audio.addEventListener('playing', function () { setBusy(false); setError(false); });
    audio.addEventListener('error', function () {
      setBusy(false); setPlaying(false); setError(true);
      if (srStatus) srStatus.textContent = L('load_error');
    });
    if (retryBtn) {
      retryBtn.addEventListener('click', function () {
        setError(false); setBusy(true);
        audio.load();
        audio.play().catch(function () { setPlaying(false); });
      });
    }
    // Replay model (CS-05): when a track finishes, reset it to the start — paused, same track.
    // No silent auto-advance (that made the player "walk" through the genre on its own).
    audio.addEventListener('ended', function () {
      try { audio.currentTime = 0; } catch (e) {}
      setPlaying(false);
      updateTime();
    });

    // expose a tiny controller for Theme Editor block selection / unload
    root._orbit = {
      selectByBlockId: function (blockId) {
        for (var i = 0; i < tracks.length; i += 1) {
          if (tracks[i].blockId && tracks[i].blockId === blockId) { selectTrack(i, false); return true; }
        }
        return false;
      },
      stop: function () { try { audio.pause(); } catch (e) {} }
    };

    selectTrack(current, false, false);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-styles-orbit]').forEach(initOrbit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-styles-orbit]');
    if (root && root._orbit) root._orbit.stop();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-styles-orbit]');
    var blockId = e.detail && e.detail.blockId;
    if (root && root._orbit && blockId) root._orbit.selectByBlockId(blockId);
  });
  document.addEventListener('shopify:block:deselect', function () {});
})();
